import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Menu, MenuItem, ListItemIcon, Typography } from "@material-ui/core";
import { Chat, FileCopy } from "@material-ui/icons";
import { toast } from "react-toastify";
import NewTicketModal from "../NewTicketModal";

const useStyles = makeStyles((theme) => ({
  phoneLink: {
    color: "#25D366", // Verde WhatsApp
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: 500,
    "&:hover": {
      opacity: 0.8,
    },
  },
  menuItemText: {
    fontSize: 14,
  },
}));

const ClickablePhone = ({ children }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);

  const rawPhone = typeof children === "string" ? children : (Array.isArray(children) ? children.join("") : "");
  // Extract just the numbers to be used for the contact creation and copying
  const numericPhone = rawPhone.replace(/\D/g, "");

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setAnchorEl(null);
  };

  const handleCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard.writeText(numericPhone);
    toast.success("Número copiado!");
    handleCloseMenu();
  };

  const handleChat = (e) => {
    e.stopPropagation();
    e.preventDefault();
    handleCloseMenu();
    setTicketModalOpen(true);
  };

  return (
    <>
      <span className={classes.phoneLink} onClick={handleOpenMenu}>
        {children}
      </span>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleChat}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <Chat fontSize="small" />
          </ListItemIcon>
          <Typography className={classes.menuItemText}>
            Conversar com {rawPhone}
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleCopy}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <FileCopy fontSize="small" />
          </ListItemIcon>
          <Typography className={classes.menuItemText}>
            Copiar número de telefone
          </Typography>
        </MenuItem>
      </Menu>

      {ticketModalOpen && (
        <NewTicketModal
          modalOpen={ticketModalOpen}
          onClose={() => setTicketModalOpen(false)}
          initialContact={{ number: numericPhone }}
        />
      )}
    </>
  );
};

export default ClickablePhone;
